<template>
  <div>
    <!-- <pre>{{ student_answer_list }}</pre> -->
    <!-- <pre>{{ summaryDetails }}</pre> -->

    <vx-card title="Grade Summary" class="mb-4">      
        <vs-button
            style="font-size: 13.8px; padding: 7px; float: right; margin-top: -50px"
            @click.prevent="maximizeCard = !maximizeCard"
            >{{ maximizeCard ? `Minimize` : `Maximize` }}</vs-button
        >
        <div class="vx-row" v-if="maximizeCard">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" v-for="(summary, index) in summaryDetails" :key="index">
            <statistics-card-line
              hideChart
              class="mb-1"
              icon="insights"
              icon-right
              :module_name="`${summary.type} Total Points`"
              :homework_total_points="summary.total"
              :exam_total_points="summary.total"
              :statistic="summary.scored"
              :statisticTitle="`${summary.subject} ${summary.type}`"
            />
          </div>
        </div>
    </vx-card>

    <vs-card>
      <h4 class="text-center">Related Information</h4>
      <vs-divider />
      <vs-row>
        <vs-col class="text-center p-2" vs-lg="6" vs-sm="12">
          <div class="flex flex-wrap justify-between header_info">
            <h5>Student Name</h5>
            <span>{{ student_name }}</span>
          </div>
        </vs-col>

        <vs-col class="text-center p-2" vs-lg="6" vs-sm="12">
          <div class="flex flex-wrap justify-between header_info">
            <h5>Class Name</h5>
            <span>{{ class_name }}</span>
          </div>
        </vs-col>

        <vs-col class="text-center p-2" vs-lg="6" vs-sm="12">
          <div class="flex flex-wrap justify-between header_info">
            <h5>Session</h5>
            <span>{{ session_name }}</span>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>

    <vs-card class="marks_card">
      <mark-entry 
        :answer_list="student_answer_list" 
        :client_user_id="client_user_id" 
        :user_course_answer_master_id="user_class_answer_master_id"
        :class_id="class_id"
        :edit_permission="edit_permission"
      />
    </vs-card>
  </div>
</template>

<script>
import { getStudentAnswerDetail } from '@/api/classes'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import MarkEntry from './MarkEntry.vue'

export default {
  name: 'mark-list',
  components: {
    StatisticsCardLine,
    MarkEntry
  },
  data () {
    return {
      maximizeCard: true,
      customer_id: localStorage.getItem('customer_id'),
      class_id: this.$route.params.class_id,
      client_user_id: this.$route.params.student_id,
      user_class_answer_master_id: this.$route.params.user_class_answer_master_id,
      student_name: this.$route.params.student_name,
      class_name: this.$route.params.class_name,
      session_name: this.$route.params.session_name,
      is_archived: this.$route.query.is_archived,
      edit_permission: this.$route.params.edit_permission,
      student_answer_list: [],
      homework_total_points: 0,
      exam_total_points: 0,
      homework_exam_total_points: 0,
      homework_statistic: 0,
      exam_statistic: 0,
      total_statistic: 0,
      summaryDetails: []
    }
  },
  created () {
    if (!this.$route.params.student_name) {
      this.$router.push({ 
        name: 'class-details', 
        params: { 
          class_id: this.class_id
        },
        query: {
          is_archived: this.is_archived
        }
      })
    } else {
      this.getStudentAnswerDetail()
    }
  },
  methods: {
    async getStudentAnswerDetail () {
      const payload = {
        class_id: this.class_id,
        client_user_id: this.client_user_id,
        user_class_answer_master_id: this.user_class_answer_master_id
      }

      try {
        const response = await getStudentAnswerDetail(this.customer_id, payload)
        this.student_answer_list = response.data.data.answerslist

        this.generateSummary()
      } catch (e) {
        console.log(e)
      }
    },
    generateSummary () {
      const homeworkData = []
      const examData = []


      this.student_answer_list.map(eachSubject => {
        eachSubject.assignments.homework.map((x) => {
          
          this.$set(x, 'sub_total_marks', 0)
          this.$set(x, 'sub_total_marks_given', 0)

          return x.question_answers
            .map((y) => {
              if (y.answers.user_class_answer_master_id !== undefined) {
                if (y.answers.mark !== null) {
                  x.sub_total_marks_given += Number(y.answers.mark)
                }
              }
              x.sub_total_marks += y.questions.point
            })
            .filter(Boolean)
        })

        eachSubject.assignments.exam.map((x) => {
          
          this.$set(x, 'sub_total_marks', 0)
          this.$set(x, 'sub_total_marks_given', 0)

          return x.question_answers
            .map((y) => {
              if (y.answers.user_class_answer_master_id !== undefined) {
                if (y.answers.mark !== null) {
                  x.sub_total_marks_given += Number(y.answers.mark)
                }
              }
              x.sub_total_marks += y.questions.point
            })
            .filter(Boolean)
        })
      })
      

      this.student_answer_list.map(eachSubject => {
        let homeworkTotal = 0
        let homeworkTotalGiven = 0

        let examTotal = 0
        let examTotalGiven = 0

        eachSubject.assignments.homework.map(eachHomework => {
          homeworkTotal += parseInt(eachHomework.sub_total_marks)
          homeworkTotalGiven += parseInt(eachHomework.sub_total_marks_given)
        })

        eachSubject.assignments.exam.map(eachExam => {
          examTotal += parseInt(eachExam.sub_total_marks)
          examTotalGiven += parseInt(eachExam.sub_total_marks_given)
        })

        homeworkData.push({ subject: eachSubject.subject, type: 'Homework', total: homeworkTotal, scored: homeworkTotalGiven })
        examData.push({ subject: eachSubject.subject, type: 'Exam', total: examTotal, scored: examTotalGiven })
      })

      //console.log('home', homeworkData)
      //console.log('exam', examData)

      this.summaryDetails = [...homeworkData, ...examData]
    }
  }
}
</script>

<style scoped>
.header_info {
  background-color: #f0f8ffc2;
    padding: 10px;
}
</style>